// hooks/useTenantConfig.ts
import { useMemo } from 'react';
import tenantConfigs from "../utils/context/tenantConfigs";
const useTenantConfig = () => {
    // Leggi la variabile dall'ambiente
    const tenant = `tenant_${process.env.MIX_APP_TENANT}` || 'default';
    // Calcola la configurazione basata sul tenant
    const config = useMemo(() => {
        return tenantConfigs[tenant] || tenantConfigs.default;
    }, [tenant]);
    return config;
};
export default useTenantConfig;
